import { PropsWithChildren } from "react";
import { RootProviders } from "components/App/RootProviders";
import { Header } from "components/Header";
import "styles/index.scss";
import s from "./App.module.scss";

type AppShellProps = PropsWithChildren<{
  currentStep: 1 | 2 | 3;
  onNext?: () => void;
  onBack?: () => void;
  nextDisabled?: boolean;
  nextLabel?: string;
}>;

const AppShell = ({ children, currentStep, onNext, onBack, nextDisabled, nextLabel }: AppShellProps) => {
  return (
    <div className={s.app}>
      <Header
        currentStep={currentStep}
        onNext={onNext}
        onBack={onBack}
        nextDisabled={nextDisabled}
        nextLabel={nextLabel}
      />
      {children}
    </div>
  );
};

export const App = ({ children, ...shellProps }: AppShellProps) => {
  return (
    <RootProviders>
      <AppShell {...shellProps}>{children}</AppShell>
    </RootProviders>
  );
};

export default App;
